import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  signal,
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButton } from '@angular/material/button';
import {
  MatFormField,
  MatLabel,
  MatSuffix,
} from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';

export type SignInRequest = {
  email: string;
  password: string;
};

type SignInForm = {
  email: FormControl<string>;
  password: FormControl<string>;
};

@Component({
  selector: 'app-sign-in-form',
  templateUrl: './sign-in-form.component.html',
  styleUrl: './sign-in-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatIcon,
    MatSuffix,
    MatButton,
  ],
})
export class SignInFormComponent {
  public readonly buttonText = input.required<string>();

  public readonly signInRequest = output<SignInRequest>();

  protected readonly signInForm = new FormGroup<SignInForm>({
    email: new FormControl(history.state.email, {
      nonNullable: true,
      validators: [
        Validators.required,
        Validators.email,
        Validators.maxLength(150),
      ],
    }),
    password: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required],
    }),
  });

  protected readonly hidePassword = signal(true);

  protected toggleHidePassword(): void {
    this.hidePassword.update((hidePassword) => !hidePassword);
  }

  protected onSubmit(): void {
    const email = this.signInForm.controls.email.value.trim();
    const password = this.signInForm.controls.password.value;
    this.signInRequest.emit({ email, password });
  }
}
